// redux/states/auth/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const sallerLogin = createAsyncThunk(
  "auth/sallerLogin",
  async (userDetails, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/login`, userDetails);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Login failed"
      );
    }
  }
);

export const sallerProfile = createAsyncThunk(
  "auth/sallerProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/profile`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Login failed"
      );
    }
  }
);
